import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { WEME_ORGANIZATION_ID } from "@shared/helpers/constants";
import { Roles } from "@shared/Roles";
import { remult } from "remult";

import { type Organization } from "./entity";

export const OrganizationEntityConfig: HyperEntityConfig<Organization> = {
  allowApiCrud: [...Roles.OrganizationManagers, Roles.SuperDuperAdmin],
  allowApiRead: true,
  apiPrefilterPerRole(filter) {
    if (!remult.user) return;

    filter(Roles.SuperDuperAdmin, true);

    filter(Roles.OrganizationManagers, {
      id: remult.user.organizationId,
    });

    filter(Roles.User, true);
  },

  allowInsertPerRole(allow) {
    allow(Roles.SuperDuperAdmin, true);
  },

  allowDeletePerRole(allow) {
    allow(Roles.SuperDuperAdmin, true);
  },

  allowUpdatePerRole(allow) {
    allow(Roles.SuperDuperAdmin, true);

    allow(
      Roles.SuperAdmin,
      (entity) => entity.id === remult.user!.organizationId,
    );
  },
};
